import React from 'react';
export function Footer() {
  return <footer className="bg-[#050E22] border-t border-[#D89B16]/30 py-10 px-4 text-center" data-id="element-90" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white/60" data-id="element-91" data-mp="3ggty8ibanj58">© Judo Coach Ready 2026 — All rights reserved.</p>
    </footer>;
}